var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "9", height: "9", viewBox: "0 0 9 9", fill: "none" }, props),
    React.createElement("path", { d: "M7.256.256a.876.876 0 0 1 1.239 1.239l-2.881 2.88 2.88 2.881a.876.876 0 0 1-1.238 1.239l-2.88-2.881-2.881 2.88A.876.876 0 0 1 .256 7.257l2.881-2.88-2.88-2.881A.876.876 0 0 1 1.494.256l2.88 2.881L7.256.257z", fill: "#B7B7B7" })
  );
});